import { observer } from 'mobx-react';
import * as React from 'react';
import RiskCalculatorInputs from "../RiskCalculatorInputData/RiskCalculatorInputs";
import { dataStore } from '../../stores/data-store';

@observer
class Composer extends React.Component {
  render() {
	return (
		<div>
			<RiskCalculatorInputs store={ dataStore } />
		</div>
	);
  }
}

export default Composer;




// WEBPACK FOOTER //
// ./src/components/Composer/Composer.js